import { useCallback, useState } from "react";
import { Modal } from "antd";
import { LockOutlined } from "@ant-design/icons";

export const useLockedFeature = () => {
  const [open, setOpen] = useState(false);

  const openLocked = useCallback((event) => {
    if (event) event.preventDefault();
    setOpen(true);
  }, []);

  const lockedModal = (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      onOk={() => setOpen(false)}
      okText="Понятно"
      cancelButtonProps={{ style: { display: "none" } }}
      title={
        <>
          <LockOutlined style={{ marginRight: 8 }} />
          Функция пока недоступна
        </>
      }
    >
      <p>Этот раздел ещё не подключён к вашему аккаунту. Напишите вашему менеджеру, чтобы открыть данный функционал.</p>
    </Modal>
  );

  return { openLocked, lockedModal };
};
